
<template>
    <main class="main-wrapper">
                <section class="qt-external-project">
                    <div class="qt-container">
                        <div class="qt-shadow-box">
                            <!-- Heading -->
                            <div class="qt-heading-row">
                                <div class="qt-heading-left">
                                     <h3 class="qt-main-head qt-main-head-icon">Employee Position Overview
                                        <span class="qt-tooltic-icon"
                                        id="qt-tooltip-trigger"><svg width="22px" height="22px" viewBox="0 0 24 24" fill="none">
                                            <path
                                                d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                                                stroke="#000000" stroke-width="1.5" stroke-linecap="round"
                                                stroke-linejoin="round" />
                                            <path d="M9 9C9 5.49997 14.5 5.5 14.5 9C14.5 11.5 12 10.9999 12 13.9999"
                                                stroke="#000000" stroke-width="1.5" stroke-linecap="round"
                                                stroke-linejoin="round" />
                                            <path d="M12 18.01L12.01 17.9989" stroke="#000000" stroke-width="1.5"
                                                stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                        <span class="qt-tooltip-wrapp" id="qt-tooltip">
                                            <p>
                                                Position Name, showing the name of the position.<br>
                                                <br>
                                                Project Name, showing the name of the project that this position is related to.<br>
                                                <br>
                                                Project Type, indicating weather it is an interal or external project.<br>
                                                <br>
                                                Project Time Forecast, showing the max allowed time to be spent on the position. Unavailable for External projects.<br>
                                                <br>
                                                Time recordings, showing total time recorded on the position.<br>
                                                <br>
                                                Time Spent %, indicate how many percent of the time allocated to the position that has been spent. Unavailable for External projects<br>
                                                <br>
                                                Available Time, showing the difference between the time allocated to the position and how much has been spent. Unavailable for External projects.<br>
                                                <br>
                                                Time Release Status, indicates if there are any Non released  time registrations on this position from up till current month.

                                            </p>
                                            <i id="qt-tooltip-close"><svg width="24px" height="24px" viewBox="0 0 24 24"
                                                    fill="none">
                                                    <path d="M7 17L16.8995 7.10051" stroke="#000000" stroke-linecap="round"
                                                        stroke-linejoin="round" />
                                                    <path d="M7 7.00001L16.8995 16.8995" stroke="#000000" stroke-linecap="round"
                                                        stroke-linejoin="round" />
                                                </svg></i>
                                        </span>
                                    </span>
                                     </h3>
                                </div>
                            </div>
                        </div>
                        <!-- Table-->  
                        <DirectManagerDashboard></DirectManagerDashboard>
                    </div>
                </section>
    </main>
    </template>
      
    <script>
    import DirectManagerDashboard from './direct-manager-overview/DirectManagerDashboardRelation.vue'
    export default {
    components: {
        DirectManagerDashboard
    },
    methods:{
        toolTip(){
            setTimeout(function(){
            const qtTooltipTrigger = document.getElementById("qt-tooltip-trigger");
            const qtTtooltip = document.getElementById("qt-tooltip");
            const qtTtooltipClose = document.getElementById("qt-tooltip-close");
            // Function to toggle the tooltip's visibility
            function toggleTooltip() {
                qtTtooltip.classList.toggle("qt-visible");
            }
    
            // Add a click event listener to the tooltip trigger
            qtTooltipTrigger.addEventListener("click", toggleTooltip);
    
            // Close the tooltip when clicking outside of it
            qtTtooltipClose.addEventListener("click", function (event) {
                if (!qtTooltipTrigger.contains(event.target) && !qtTtooltip.contains(event.target)) {
                    qtTtooltip.classList.remove("qt-visible");
                }
            });
        }, 1000)
        }
        },
        mounted(){
        this.toolTip();
      }
    }
    </script>
    
      